import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sme-keys',
  templateUrl: './sme-keys.component.html',
  styleUrls: ['./sme-keys.component.scss']
})
export class SmeKeysComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
